var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcCheckboxDisabledDark = function SvgIcCheckboxDisabledDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 2.5,
    fill: "#3A3A3C",
    stroke: "#47474B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.823 8.947 13 13 7",
    stroke: "#5A5A60",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgIcCheckboxDisabledDark;